import React, { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";

import { getSchoolSettings, postSchoolSettings } from "@backend/SchoolsRequests";

import SchoolManageDeadlinesView from "./SchoolManageDeadlines.View";

// const initDeadlines = {
//     ischoolId: "",
//     preRegSchoolEndDate: null,
//     preRegSchoolAdminEndDate: null,
//     preRegStudentEndDate: null,
//     returningBooksEndDate: null,
//     schoolActiveNextYear: null,
// };

function SchoolManageDeadlinesPage() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const schoolId = searchParams.get("schoolId");

    const [dataSource, setDataSource] = useState([]);
    const [deadline, setDeadline] = useState({ process: "", deadline: "" });
    const [showDeadlinesModal, setShowDeadlinesModal] = useState(false);

    //#region Effect Hooks
    useEffect(() => {
        initCalls();
    }, []);

    //#endregion

    const initCalls = async () => {
        const response = await getSchoolSettings(schoolId);
        if (response.success) {
            setDeadlineInTable(response);
        } else {
            console.log("Error fetching deadlines:", response.error);
        }
    };

    function setDeadlineInTable(response) {
        const transformedData = [
            { process: "preRegSchoolEndDate", deadline: response.data.preRegSchoolEndDate },
            { process: "preRegSchoolAdminEndDate", deadline: response.data.preRegSchoolAdminEndDate },
            { process: "preRegStudentEndDate", deadline: response.data.preRegStudentEndDate },
            { process: "returningBooksEndDate", deadline: response.data.returningBooksEndDate },
        ];
        setDataSource(transformedData);
    }

    async function saveChanges(deadline) {
        let body = {};

        switch (deadline.process) {
            case "preRegSchoolEndDate":
                body = { preRegSchoolEndDate: deadline.deadline };
                break;
            case "preRegSchoolAdminEndDate":
                body = { preRegSchoolAdminEndDate: deadline.deadline };
                break;
            case "preRegStudentEndDate":
                body = { preRegStudentEndDate: deadline.deadline };
                break;
            case "returningBooksEndDate":
                body = { returningBooksEndDate: deadline.deadline };
                break;
            default:
                break;
        }

        return await postSchoolSettings(schoolId, body);
    }

    //#region Handlers
    async function handleDeadlinesModalSave() {
        const resp = await saveChanges(deadline);

        if (!resp.success) {
            throw new Error("Error saving deadlines.");
        }

        setShowDeadlinesModal(false);

        const newDeadlines = await getSchoolSettings(schoolId);

        if (!newDeadlines.success) {
            throw new Error("Error fetching updated deadlines.");
        }
        setDeadlineInTable(newDeadlines);
    }

    /**
     * @param {any} event
     */
    function handleEditButtonClick(event) {
        setDeadline({ process: event.process, deadline: event.deadline.split("T")[0] });
        setShowDeadlinesModal(true);
    }

    //#endregion

    const deadlineModal = {
        deadline: deadline,
        onDeadlinesModalInputChange: (e) => setDeadline({ ...deadline, deadline: e.target.value }),
        showDeadlinesModal: showDeadlinesModal,
        onDeadlinesModalHide: () => setShowDeadlinesModal(false),
        onDeadlinesModalSave: handleDeadlinesModalSave,
    };

    return (
        <SchoolManageDeadlinesView
            dataSource={dataSource}
            deadlineModal={deadlineModal}
            onEditButtonClick={handleEditButtonClick}
        />
    );
}

export default SchoolManageDeadlinesPage;
